import React, { useState, useEffect, useCallback } from 'react';
import '../styles/Header.css';
import logo from '../assets/GeoParking.png';
import { Link } from 'react-scroll';
import { useLocation, useNavigate } from 'react-router-dom';

const Header = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const envname = process.env.REACT_APP_ENV_TXT || null;
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);
  const location = useLocation();

  useEffect(() => {
    const scrollToSection = location.state?.scrollTo;
    if (scrollToSection) {
      const timeout = setTimeout(() => {
        const element = document.getElementById(scrollToSection);
        if (element) {
          const topOffset = element.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: topOffset, behavior: 'smooth' });
        }
      }, 500);

      return () => clearTimeout(timeout);
    }
  }, [location]);


  const handleSignUpClick = (event) => {
    if (event.button === 0) {
      navigate('/signup');
    }
  };

  const handleLoginClick = (event) => {
    if (event.button === 0) {
      navigate('/login');
    }
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const handlereturnHome = () => {
    navigate('/Home');
  };

  const handleCompanyValues = (type) => {
    if (type === 'companyValues')
     // navigate('/mission-statement');
    navigate('/company-values');
     
    else
      navigate('/product-and-service');

  };


  return (
    <header className="header">
      <div className="logo-container">
        <div className="logo">
          <img src={logo} alt="GeoParking Technologies" />
        </div>
        {envname && <span className="restricted-badge-home">{envname}</span>}
      </div>
      <nav className={isSidebarOpen ? 'nav-links sidebar' : 'nav-links'}>
        <ul>
          <li>
            <a
              href="/home"
              target="_self"
              onClick={(e) => {
                e.preventDefault();
                handlereturnHome();
                closeSidebar();
                document.getElementById("home")?.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Home
            </a>

          </li>
          <li>
            <a
              href="/companyValues"
              onClick={(e) => {
                e.preventDefault();
                handleCompanyValues('companyValues');
              }}
            >
              Company Values
            </a>
          </li>
          <li>
            <a
              href="/productService"
              onClick={(e) => {
                e.preventDefault();
                handleCompanyValues('productService');
              }}
            >
              Product And Services
            </a>
          </li>

          <li>
            <a
              href="/Home/about-us"
              onClick={(e) => {
                e.preventDefault();
                navigate('/Home', { state: { scrollTo: 'who-are-we' } });
                closeSidebar();
              }}
            >
              About Us
            </a>
          </li>
          <li>
            <a
              href="/Home/contact-us"
              onClick={(e) => {
                e.preventDefault();
                navigate('/Home', { state: { scrollTo: 'contact-us' } });
                closeSidebar();
              }}
            >
              Contact Us
            </a>
          </li>

        </ul>
        <div className="auth-buttons">
          <a href="/signup" target="_blank" className="sign-up" onMouseDown={handleSignUpClick}>Sign Up</a>
          <a href="/login" target="_blank" className="login-1" onMouseDown={handleLoginClick}>Login</a>
        </div>
      </nav>
      <div className={`menu-toggle ${isSidebarOpen ? 'open' : ''}`} id="nav-icon3" onClick={toggleSidebar}>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
};

export default Header;
